import { render, staticRenderFns } from "./trip.vue?vue&type=template&id=4bb8b69a&scoped=true&"
import script from "./trip.vue?vue&type=script&lang=js&"
export * from "./trip.vue?vue&type=script&lang=js&"
import style0 from "./trip.vue?vue&type=style&index=0&id=4bb8b69a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb8b69a",
  null
  
)

component.options.__file = "trip.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VFlex,
  VForm,
  VTextField,
})
